import { preventIPAccess, shouldForwardStyledProp } from '@talos/kyoko';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';
import App from './App.jsx';
import './index.css';

preventIPAccess();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw Error('Could not find root element to render app into');
}
createRoot(rootElement).render(
  <StrictMode>
    <StyleSheetManager shouldForwardProp={shouldForwardStyledProp}>
      <App />
    </StyleSheetManager>
  </StrictMode>
);
